import { useState, useEffect, useRef } from 'react';

interface AnimatedNumberProps {
  value: number;
  duration?: number;
  className?: string;
}

export default function AnimatedNumber({ value, duration = 2400, className }: AnimatedNumberProps) {
  const [display, setDisplay] = useState(value);
  const prevRef = useRef(value);
  const [animating, setAnimating] = useState(false);

  useEffect(() => {
    const prev = prevRef.current;
    if (prev === value) return;

    setAnimating(true);
    const start = performance.now();
    const diff = value - prev;

    const raf = requestAnimationFrame(function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(prev + diff * eased));
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        setAnimating(false);
      }
    });

    prevRef.current = value;
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  return (
    <span className={`${className || ''} ${animating ? 'drop-animate' : ''}`}>
      {display}
    </span>
  );
}
